import { Editor, Element, Transforms } from 'slate';
import { ImageInfo, CustomSlateNodeType } from '../types';

const LyEditor = {
  ...Editor,
  insertDividingLine(editor: Editor) {
    Transforms.insertNodes(editor, {
      type: CustomSlateNodeType.DIVIDING_LINE,
      children: [{ text: '' }],
    });
  },
  insertConcept(editor: Editor, label: string) {
    Transforms.insertNodes(editor, {
      type: CustomSlateNodeType.CONCEPT,
      label,
      children: [{ text: '' }],
    });
    Transforms.move(editor, { distance: 1, unit: 'offset' });
  },
  insertParamText(editor: Editor, label: string, canEditor = true) {
    Transforms.insertNodes(editor, {
      type: CustomSlateNodeType.PARAMTEXT,
      label,
      children: [{ text: '' }],
      canEditor,
    });
    Transforms.move(editor, { distance: 1, unit: 'offset' });
  },
  insertParamHolder(editor: Editor, label: string) {
    Transforms.insertNodes(editor, {
      type: CustomSlateNodeType.PARAMHOLDER,
      label,
      children: [{ text: '' }],
    });
    Transforms.move(editor, { distance: 1, unit: 'offset' });
  },
  hasImageNode(editor: Editor) {
    const lastNode = editor.children[editor.children.length - 1];
    if (lastNode && lastNode.type === CustomSlateNodeType.IMAGE) {
      return true;
    }
    return false;
  },
  insertImage(editor: Editor, images: ImageInfo[]) {
    const hasImageNode = LyEditor.hasImageNode(editor);
    if (hasImageNode) {
      Transforms.select(editor, [editor.children.length - 1]);
      if (images.length) {
        Transforms.setNodes(
          editor,
          { images },
          {
            match: (node) => {
              return Element.isElement(node) && node.type === CustomSlateNodeType.IMAGE;
            },
          },
        );
      } else {
        Transforms.removeNodes(editor, {
          match: (node) => {
            return Element.isElement(node) && node.type === CustomSlateNodeType.IMAGE;
          },
        });
      }
    } else {
      Transforms.insertNodes(editor, {
        type: CustomSlateNodeType.IMAGE,
        images,
        children: [{ text: '' }],
      });
    }
  },
};

export default LyEditor;
